module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "table-row",
    class: {
      'clickable': _vm.editabled
    }
  }, [_c('div', {
    staticClass: "table-col text-gray-color"
  }, [_c('span', {
    staticClass: "glyphicon",
    class: _vm.custom_field.kind
  }), _vm._v(_vm._s(_vm.custom_field.field))]), (_vm.editabled) ? _c('div', {
    staticClass: "table-col text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Editar")]), _c('span', {
    staticClass: "spacer-15"
  }), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroyCustomField
    }
  }, [_vm._v("Excluir")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-35984320!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/custom_fields/list_item.vue
// module id = 1076
// module chunks = 1